import * as React from 'react';
import { Property } from '../../../../../api/Property';

interface Props {
    propertyInfo: Property;
}

const CancelledSubPage = (props: Props) => (
    <div>
        <h3>Welcome to Tour24!</h3>
        <p>Self-Guided tours at {props.propertyInfo.name} are not available at this time.</p>
        <p>
            We apologize for the inconvenience. Please contact the property directly for more
            information and for when self-guided tours will become available.
        </p>
        <p>Thanks for using Tour24!</p>
    </div>
);

export default CancelledSubPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/property/CancelledSubPage.tsx